/**
 * Progressive phone number formatting to (XXX) XXX-XXXX.
 * Strips non-digits, then formats based on length.
 */
export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, '')

  if (digits.length <= 3) {
    return digits.length > 0 ? `(${digits}` : ''
  }
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
}

/**
 * Lowercase an email value.
 */
export function lowercaseEmail(value: string): string {
  return value.toLowerCase()
}

/**
 * Validate email format. Returns true if valid or empty.
 */
export function isValidEmail(value: string): boolean {
  if (!value.trim()) return true
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

/**
 * Validate phone has 10 digits. Returns true if valid or empty.
 */
export function isValidPhone(value: string): boolean {
  if (!value.trim()) return true
  const digits = value.replace(/\D/g, '')
  return digits.length === 10
}
